import debug from 'debug';
const log = debug('fus078/components/base-behaviour');

export class Base {

	constructor(element, options) {
		this.element = element;
		this.$element = $(element);
		this.options = Base.mapAttributeOptions(
			this.constructor.componentName,
			Object.assign({}, this.constructor.DEFAULTS, options),
			this.$element.data());
		this.$element.data(this.constructor.componentName, this);
		log('attaching', this.element, this.$element, this.options);
	}

	static mapAttributeOptions (name, defaults, dataset) {
		const options = Object.keys(dataset).reduce((result, key) => {
			result[key.toLowerCase().replace(`${name}-`, '')] = dataset[key];
			return result;
		}, {});
		return Object.assign({},
			defaults,
			options);

	}
}

export class BaseAjaxForm extends Base {
	constructor (element, options) {
		super(element, options);

		this.$form = $(this.options.formselector, this.$element);
		this.$submitButton = $(this.options.submitbuttonselector, this.$element);
		this.$messages = {
			wait: $(this.options.messagewaitselector, this.$element),
			error: $(this.options.messageerrorselector, this.$element),
			success: $(this.options.messagesuccessselector, this.$element)
		};

		if (this.attachValidation && typeof this.attachValidation == 'function') {
			System.import(
				/* webpackChunkName: "vendor/jquery.validate@1.11.1" */
				'@vendor/jquery.validate@1.11.1')
				.then(this.attachValidation.bind(this));
		} else {
			console && console.warn(`${this.constructor.name} missing attachValidation method!`);
		}

		this.preflight = {
			'submit-enabled': () => !this.$submitButton.attr('disabled'),
			'form-valid': () => this.$form.valid(),
		};

		this.$submitButton.on('click', this.submit.bind(this));

		this.hideMessage('wait');
		this.hideMessage('error');
		this.hideMessage('success');
	}

	compilePayload() {
		return this.$element
			.find(this.options.payloaditemselector)
			.map((index, item) => {
				const field = $(item);
				return { name: field.attr('name'), value: field.val() };
			}).toArray()
			.reduce((payload, { name, value }) => {
				payload[name] = value;
				return payload;
			}, {});
	}

	success () {
		log('sucess');
		this.$form.hide();

		this.hideMessage('wait');
		this.hideMessage('error');
		this.showMessage('success');
		// window.scrollTo(0, 0);
	}

	error (msg) {
		log('error', {msg});
		this.hideMessage('wait');
		this.hideMessage('success');
		this.showMessage('error');
	}

	wait () {
		log('wait');
		this.showMessage('wait');
		this.hideMessage('error');
		this.hideMessage('success');
	}

	getMessageElement(type) {
		if (!type || !this.$messages[type] || !this.$messages[type].length) return;
		return this.$messages[type];
	}

	showMessage(type, timeoutMs = 1000) {
		const $messageElement = this.getMessageElement(type);
		if ($messageElement) {
			$messageElement.show();
		}
	}

	hideMessage (type) {
		if (!type || !this.$messages[type]) return;
		const $messageElement = this.$messages[type];
		$messageElement.hide();
	}

	preflightCheck (readyFn) {
		log('preflightCheck');
		const notReady = Object.keys(this.preflight)
			.map(key => {
				try {
					const result = this.preflight[key]();
					log(`preflightCheck.${key}`, result);
					return result;
				} catch (err) {
					log(`preflightCheck.${key}.fail`, {err});
					return false;
				}
			})
			.some((result) => {
				return result == false;
			});
		if (!notReady) {
			readyFn && readyFn();
		} else {
			log('preflightCheck.notReady');

			this.hideMessage('wait');
			this.hideMessage('error');
			this.hideMessage('success');

		}
	}

	submit (event) {
		event.preventDefault();
		this.wait();
		this.preflightCheck(() => {
			log('BaseAjaxForm.submit.send');
			this.send();
		});
	}

	send() {
		var payload = this.compilePayload();
		var token = this.$form.find('input[name="__RequestVerificationToken"]').val();
		var headers = { "X-RVT": token };

		$.ajax({
			url: this.$form.attr('action'),
			type: 'POST',
			data: payload,
			headers: headers,
			success: (data, response) => {
				this.$submitButton.removeAttr('disabled');
				if (data) {
					this.success();
				}
				else {
					this.error();
				}
			}
		});
	}

}

export class BaseAjaxRecaptchaForm extends BaseAjaxForm {
	constructor(element, options) {
		super(element, options);

		this.$recaptchaElement = $(this.options.recaptchaelementselector, this.$element);
		$script(['//www.google.com/recaptcha/api.js?onload=ON_RECAPTCHA_READY&render=explicit'], 'recaptcha');
		$script.ready('recaptcha', this.attachRecaptcha.bind(this));
	}

	recaptchaResponse (token) {
		this.send(token);
	}

	recaptchaExpired () {
		window.grecaptcha.reset();
	}

	recaptchaError () {
		this.hideMessage('wait');
		this.hideMessage('success');
		this.showMessage('error');
	}

	compilePayload () {
		const payload = super.compilePayload();
		return Object.assign({}, payload, {
			"recaptchaResponse": grecaptcha.getResponse(this.recaptchaId)
		});
	}

	attachRecaptcha () {
		ON_RECAPTCHA_READY.ready(() => {
			if (this.recaptchaReady) { return; }
			const element = this.$recaptchaElement.get(0);

			if (element) {
				this.recaptchaId = window.grecaptcha.render(element, {
					'sitekey': this.options.recaptchasitekey,
					'callback': this.recaptchaResponse.bind(this),
					'expired-callback': this.recaptchaExpired.bind(this),
					'error-callback': this.recaptchaError.bind(this),
					'size': this.options.recaptchasize
				});
				this.recaptchaReady = true;
				this.$submitButton.attr('disabled', false);
				log('recaptcha.attached', this);
			}
		});
	}

	submit (event) {
		event.preventDefault();

		this.showMessage('wait');
		this.hideMessage('error');
		this.hideMessage('success');

		this.preflightCheck(() => {
			log('BaseAjaxRecaptchaForm.submit.executeRecaptcha');
			grecaptcha.execute(this.recaptchaId);
		});
	}

}

function ON_RECAPTCHA_READY () {
	log('ON_RECAPTCHA_READY');
	ON_RECAPTCHA_READY.isReady = true;
	ON_RECAPTCHA_READY.fns.forEach((fn) => fn());
};
ON_RECAPTCHA_READY.fns = [];
ON_RECAPTCHA_READY.ready = function (fn) {
	ON_RECAPTCHA_READY.fns.push(fn);
};
ON_RECAPTCHA_READY.isReady = false;
window.ON_RECAPTCHA_READY = ON_RECAPTCHA_READY;


// WEBPACK FOOTER //
// ./client/src/site__fus078/components/base-behaviour/index.js